<template>
    <b-col :class="computedBackground" class="pmis-lala" :lg="cols">
        <div :class="computedDarkBackground" class="pmis-presentation-title">
            <input id="new-solution-title" class="title-input" type="text" placeholder="Naslov">
        </div>
        <ul id="new-solution-features">
            <li><span :class="[computedDarkBackground, computedDarkTextColor]">*</span>
                <div>glava</div>
            </li>
            <li :key="feature" v-for="feature in features">
                <span :class="[computedDarkBackground, computedDarkTextColor]">*</span>
                <input :id="feature.replace(' ','_')" type="text" class="pmis-presentation-text" :placeholder="feature">
            </li>
        </ul>
    </b-col>
</template>

<script>
    import {pmisColorsMixin} from "../../../mixins/pmis-colors-mixin";

    export default {
        name: "PmisFormPresentationFeatures",
        props: {
            name: String,
            title: String,
            features: Array,
            cols: Number
        },
        mixins: [pmisColorsMixin]
    }
</script>

<style lang="scss" scoped>

    .title-input {
        color: white;
    }

    .title-input::placeholder {
        color: #F9F9F9;
    }

    input[type="text"] {
        background: transparent;
        border: none;
        outline: none;
    }

    .pmis-lala {
        position: relative;
        z-index: 1;
        margin-top: 10px !important;
    }

    .pmis-presentation-title {
        font-family: "Roboto";
        font-size: 2.7em;
        border-radius: 10px;
        margin: 5px 10px;
        padding: 0px;
        text-align: center;
        position: relative;
        z-index: 3;
        color: white;
    }

    .pmis-presentation-text {
        font-family: "Roboto";
        font-size: 1.4em;
        margin-left: 1.5em;
    }

    ul {
        list-style: none;
    }

    input {
        color: $pmis-grey;
    }

    ul li {
        padding-bottom: 30px;
        position: relative;
        top: -40px;
        color: $pmis-grey-light;
        font-size: 1.3em;
        font-family: "Helvetica Neue";
    }

    ul li span {
        border-radius: 5px;
        border: 3px solid white;
        padding: 5px 10px;
        margin-right: 10px;
        width: 35px;
        height: 35px;
        float: left;
    }

    ul li span:before {
        content: '';
        position: absolute;
        border-left: 4px solid white;
        left: 16px;
        bottom: 0;
        z-index: -1;
        height: 100%;
    }

    ul li:last-child span:before {
        content: none;
    }

    ul li:last-child {
        padding-bottom: 0
    }
</style>
